import type { Metadata } from "@/lib/head";

import ConstructionNotice from "@/modules/print/construction-notice";
import PrintPreviewShell from "@/modules/print/print-preview-shell";
import type { ProjectNoticeView } from "@buildpy/core/views/g3b/project-notice";

export const metadata: Metadata = { title: "공사 안내문" };

interface Props {
  data: ProjectNoticeView;
}

// 기본 작업 시간 — 공동주택 관리규약에서 흔한 평일 작업 시간.
const DEFAULT_HOURS = "09:00 ~ 18:00";

// 공사 안내문 인쇄 — 권한은 현장 상세와 같다(그 조직 멤버). QR 은 이 현장 id 를 단 간편접수 주소다(core 읽기가 만든다).
const Page = ({ data }: Props) => {
  const { project } = data;

  return (
    <PrintPreviewShell closeHref={`/app/projects/${project.id}`} subtitle={project.title} title="공사 안내문">
      <ConstructionNotice
        contractorName={data.contractorName}
        contractorTel={data.contractorTel}
        defaults={{
          address: project.site_address,
          startDate: project.planned_start_date ?? "",
          endDate: project.planned_end_date ?? "",
          hours: DEFAULT_HOURS,
          work: project.title,
        }}
        qrSvg={data.qrSvg}
      />
    </PrintPreviewShell>
  );
};

export default Page;
